import React, { ComponentType } from 'react';
import { useRouter } from 'next/router';
import type { ITimeZone } from '@dealroadshow/uikit-date-time';
import { useUserTimeZoneContext } from '@/creditflowresearch/application/User/UserTimeZone/UserTimeZoneContext';
import Inventory from './Inventory';
import Bwic from './Bwic';
import { IColumn } from '@creditflowresearch/uilib/Table/DataTable/interfaces/Column';
import { IAssetClass } from '@/creditflowresearch/domain/vo/IAssetClass';

interface IProps {
  tableFooterLabel: React.ReactNode,
  bwicRow: React.FC | ComponentType,
  inventoryRow: React.FC | ComponentType,
  getBwicHeaderColumns: (
    columnsConditions: Record<string, boolean> | undefined,
    timeZone: ITimeZone,
  ) => IColumn[],
  getInventoryHeaderColumns: () => void,
  currentAssetClass: IAssetClass,
}

const BondTables = ({
  tableFooterLabel,
  bwicRow,
  inventoryRow,
  getBwicHeaderColumns,
  getInventoryHeaderColumns,
  currentAssetClass,
}: IProps) => {
  const { query: { bondType } } = useRouter();
  const { timeZone } = useUserTimeZoneContext();

  return (
    <>
      {
        bondType === 'bwics'
        ? (
          <Bwic
            tableFooterLabel={ tableFooterLabel }
            getHeaderColumns={ getBwicHeaderColumns }
            bwicRow={ bwicRow }
            timeZone={ timeZone }
            currentAssetClass={ currentAssetClass }
          />
        )
        : (
          <Inventory
            tableFooterLabel={ tableFooterLabel }
            getHeaderColumns={ getInventoryHeaderColumns }
            inventoryRow={ inventoryRow }
            currentAssetClass={ currentAssetClass }
          />
        )
      }
    </>
  );
};

export default BondTables;
